import { Button } from '@material-ui/core';
import PropTypes from 'prop-types';

export function AddBootDbButton({ setKitID }) {
  const handleAddBootDb = () => {
    setKitID('617175');
  };

  return (
    <Button
      size="small"
      variant="outlined"
      color="secondary"
      onClick={handleAddBootDb}
      sx={{ mx: 1 }}
    >
      Add Boot DB Kit
    </Button>
  );
}

AddBootDbButton.propTypes = {
  setKitID: PropTypes.func
};
